import styled from 'styled-components';

export const CompletedStyles = styled.div`
  .completed-img {
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    img {
      height: 200px;
      width: auto;
    }
  }
  .completed-text {
    text-align: center;
    span,
    a {
      color: ${(props) => props.theme.primary.primary50};
      display: block;
    }
    p {
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
  .remember-text,
  .media-text {
    text-align: center;
    margin: 16px 0 16px 0;
    font-size: 16px;
    line-height: 24px;
    padding-top: 24px;
  }
  .vas-button {
    background-color: #0094d9;
    color: #ffffff;
    box-shadow: none;
    padding: 18px 24px;
    height: 56px;
    min-width: 56px;
    font-size: 16px;
    line-height: 16px;
  }
`;
